import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { FaCheck, FaEnvelope, FaEnvelopeOpen, FaEnvelopeOpenText, FaFilePdf, FaPen, FaRegHandPaper, FaRegQuestionCircle, FaTimes, FaTrash } from 'react-icons/fa';
import InfoComplete from './InfoComplete';
import InfoToValidate from './InfoToValidate';
import GenereCsv from './GenereCsv';
import InfoCotisation from './InfoCotisation';
import { cleanJson, quoteToDoubleQuote } from './utils/Columns';
import CotisationSel from './CotisationSel';
import TarifManuel from './TarifManuel';
import AdherentNewUpdate from './AdherentNewUpdate';
import InfoAdhesion from './InfoAdhesion';
import InfoAdherent from './InfoAdherent';
import InfoCotisationSel from './InfoCotisationSel';
import AdhesionByUser from './AdhesionByUser';
import ColumnChooser from './ColumnChooser';
import moment from 'moment';
import AdherentUpdateById from './AdherentUpdateById';

const AdhesionManuelle = ({ gotoAuth }) => {

    const url = localStorage.getItem('url');
    const smallurl = localStorage.getItem('smallurl');
    const cotisations = JSON.parse(localStorage.getItem('cotisations')) || [];

    const [showMaj, setShowMaj] = useState(false);
    const [adherentSel, setAdherentSel] = useState({});
    // Filtrer les articles initialisés et non initialisés
    const code = localStorage.getItem('code');

    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState([]);
    const [dataFiltered, setDataFiltered] = useState([]);
    const [allData, setAllData] = useState([]);
    const [titre, setTitre] = useState('');

    useEffect(() => {
        if (url && url !== '') {
            getData();
        }
    }, []);

    const filtreData = (mydata) => {
        let donnees = mydata;

        setData(donnees);
        filtre(searchText, donnees);
    }
    // validated

    const getData = () => {
        console.log('code', code);
        if (code === '') {
            gotoAuth();
            return;
        }
        // Appel de l'API
        fetch(`${url}GetCotisationsAdherents/${code}`)
            .then(response => response.json())
            .then(data => {
                // Traiter la réponse si nécessaire
                console.log('Réponse du serveur:', data);
                if (data === '0' || !data.data)
                    gotoAuth();
                else {
                    setShowTarif(false)
                    let donnees = cleanJson(data.data);
                    setAllData(donnees);
                    filtreData(donnees);
                    if (JSON.stringify(adherentSel) !== '{}') {
                        let adh = donnees.find(e => e.adherent_id === adherentSel.adherent_id);
                        console.log('adh', adh);
                        setAdherentSel(adh);
                    }
                }
            })
            .catch(error => console.error('Erreur:', error));
    }

    const filtre = (value, mydata) => {
        // console.log('filtre', value, mydata);
        setSearchText(value);
        if (value.length < 1) {
            setDataFiltered(mydata);
        } else {
            const filtered = mydata.filter(item => {
                // must contains all word of value
                return value.split(' ').every(word => {
                    return JSON.stringify(item).toLowerCase().includes(word.toLowerCase());
                });
            });
            setDataFiltered(filtered);
            // console.log(filtered);
        }
    }

    const handleChangesearchText = (e) => {
        filtre(e.target.value, data);
    };

    const [showCotis, setShowCotis] = useState(false);
    const [cotisationSel, setCotisationSel] = useState({});

    const [showTarif, setShowTarif] = useState(false);
    const [showCotisSel, setShowCotisSel] = useState(false);

    const handleDelCotisation = () => {
        console.log('handleDelCotisation', adherentSel);
        if (window.confirm(`Êtes vous sûr de supprimer la cotisation de ${adherentSel.nom_de_l_entreprise} - ${adherentSel.prenom_adherent} ${adherentSel.nom_adherent} ?`)) {

            fetch(`${url}AffecteCotisation/${adherentSel.adherent_id}/0/0`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        alert("rien à envoyer")
                    else {
                        console.log(data.data);
                        getData();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }



    const handleChoixCotisation = (e) => {
        console.log('handleChoixCotisation', e)
        let reference = cotisations.find(c => c.id === e.cotisation_id).reference;
        // console.log('handleChoixCotisation', e, reference);
        console.log('handleChoixCotisation', adherentSel);
        if (window.confirm(`Êtes vous sûr d'affecter la ${reference} à ${adherentSel.nom_de_l_entreprise} - ${adherentSel.prenom_adherent} ${adherentSel.nom_adherent} ?`)) {

            fetch(`${url}AffecteCotisation/${adherentSel.adherent_id}/${e.cotisation_id}/${e.choix_id}`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        alert("rien à envoyer")
                    else {
                        console.log(data.data);
                        getData();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    const [columnsSel, setColumnsSel] = useState(['Siret', 'Entreprise', 'Nom', 'Adresse', 'E-mail']);
    // const [columnsSel, setColumnsSel] = useState(['Siret', 'Entreprise', 'Nom', 'Adresse', 'Code postal', 'Ville', 'Téléphone', 'E-mail']);
    const [columns, setColumns] = useState([]);
    const [adherentIdSel, setAdherentIdSel] = useState(0);

    const handleMaj = (row) => {
        console.log(row);
        setAdherentIdSel(row.adherent_id);
        setShowMaj(true);
    }

    const handleRowClick = (row) => {
        console.log('Ligne cliquée :', row);
        //index of etats where etat = row.etat
        setAdherentSel(row);
    };

    const uniqueNetworks = [...new Set(data.map(row => row.reseau))].sort();
    const [selectedNetwork, setSelectedNetwork] = useState('');
    const handleNetworkFilter = (network) => {
        setSelectedFeuille('');
        setSelectedNetwork(network);
        // Appliquer le filtre sur les données en fonction du réseau sélectionné
        if (network === '') {
            setDataFiltered(data);
        } else {
            const filtered = data.filter(item => item.reseau === network);
            setDataFiltered(filtered);
        }
    };

    const uniqueFeuilles = [...new Set(data.map(row => row.reference))].sort();
    const [selectedFeuille, setSelectedFeuille] = useState('');
    const handleFeuilleFilter = (feuille) => {
        setSelectedNetwork('');
        setSelectedFeuille(feuille);
        // Appliquer le filtre sur les données en fonction du réseau sélectionné
        if (feuille === '') {
            setDataFiltered(data);
        } else {
            const filtered = data.filter(item => item.reference === feuille);
            setDataFiltered(filtered);
        }
    };

    const [showNew, setShowNew] = useState(false);

    const handleSaveAdherent = (editedAdh) => {
        fetch(`${url}NewAdherent/${code}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            // remplace 'Invalid date' par '' dans le JSON
            body: JSON.stringify(quoteToDoubleQuote(editedAdh)).replace(/"Invalid date"/g, '""')
        })
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
                setAdherentSel(data);
                setShowNew(false);
                getData();
            })
            .catch(error => console.error('Erreur:', error));
    }
    const blocs = ['infoAdh', 'entreprise', 'effectif', 'abonnement', 'adhesion', 'cotisation', 'tribu', 'siv', 'membre'];
    const champs = [
        { lib: 'civilite', required: false }, { lib: 'prenom_adherent', required: false }, { lib: 'nom_adherent', required: false }, { lib: 'adresse1', required: false }, { lib: 'adresse2', required: false }, { lib: 'code_postal', required: false, longueur: 5 }, { lib: 'ville', required: false }, { lib: 'telephone', required: true }, { lib: 'numero_de_portable', required: false }, { lib: 'e_mail_1', required: true }, { lib: 'e_mail_2', required: false }, { lib: 'e_mail_3', required: false }, { lib: 'numero_de_dpt', required: false }, { lib: 'numero_client', required: false }, { lib: 'region', required: false },

        { lib: 'nom_de_l_entreprise', required: false }, { lib: 'siret', required: true, longueur: 14 }, { lib: 'numero_tva_intracommunautaire', required: false }, { lib: 'code_ape_ou_naf', required: false }, { lib: 'forme_juridique_de_la_societe', required: false }, { lib: 'montant_du_capital', required: false }, { lib: 'code_metier', required: false },

        { lib: 'nbre_productifs', required: false }, { lib: 'nbre_apprentis', required: false }, { lib: 'total_personnel', required: false },


        { lib: 'acces_site_ffc_newsletter', required: false },

        { lib: 'acces_mediateur_consommation', required: false }, { lib: 'enregistre_site_ffc', required: false }, { lib: 'enregistre_site_mediation', required: false },

        { lib: 'reseau', required: false }, { lib: 'adh_depuis', required: true }, { lib: 'annee_de_cotisation', required: false }, { lib: 'date_paiement', required: false }, { lib: 'cotisation_nationale_t1', required: false }, { lib: 'cotisation_reseau', required: false }, { lib: 'cotisation_regionale', required: false }, { lib: 'cotisation_3_ans', required: false }, { lib: 'mode_de_paiement', required: false }, { lib: 'paiement_en_x_fois', required: false }, { lib: 'cnpa', required: false }, { lib: 'fnaa', required: false }, { lib: 'autre', required: false }, { lib: 'cotisation_id', required: false },

        { lib: 'has_tribu', required: false }, { lib: 'date_de_reglement', required: false }, { lib: 'fin_periode', required: false }, { lib: 'montant_tribu_regle_t2', required: false }, { lib: 'moyen_de_paiement', required: false }, { lib: 'paiement_en_x_fois', required: false }, { lib: 'identifiant_tribu', required: false },

        { lib: 'has_siv', required: false }, { lib: 'date_de_reglement_siv', required: false }, { lib: 'fin_periode_siv', required: false }, { lib: 'montant_regle_siv', required: false }, { lib: 'moyen_de_paiement_siv', required: false }, { lib: 'paiement_en_x_fois_siv', required: false },

        { lib: 'membre_bureau_ffc', required: false }, { lib: 'membre_conseil_national', required: false }, { lib: 'membres_conseil_admin', required: false }, { lib: 'titre', required: false },
    ];

    const handleSetColumns = (cols) => {
        console.log(cols);
        // ajouter : {
        //     name: 'Actions', width: '80px', cell: row => (<>
        //         <Button variant='secondary' onClick={() => handleShow(row)}><FaPen /></Button>
        //     </>),
        // },
        let colsNew = [
            ...cols, {
                name: 'Payé', width: '120px', selector: row => row.paid, cell: row => (<>
                    {row.paid===1 && <div style={{ color: 'green', padding: '5px', textAlign: 'center' }}><FaCheck /><br />{row.date_paiement_final}
                    {row.cotisation_id1===7 && <><br/>3 ans</>}</div>}
                </>), sortable: true, wrap: true
            },
            {
                name: 'Type', width: '120px', selector: row => row.type, cell: row => (<>
                    {row.type}
                    {/* {row.paid===1 && <>{row.type}
                    <br />{row.date_creation}
                    </>} */}
                </>), sortable: true, wrap: true
            },
            {
                name: 'Actions', width: '80px', cell: row => (<>
                    <Button variant='secondary' onClick={() => handleMaj(row)}><FaPen /></Button>
                </>),
            },
            
        ]
        setColumns(colsNew);
    }
    return (
        <div>
            {/* <Button variant="secondary" onClick={() => setShowNew(true)}>
                Nouvel adhérent
            </Button>
            a envoyer : <FaPaperPlane />
            envoyé : <FaEnvelope />
            connecté sur le site :<FaEnvelopeOpen />
            mergé : <FaEnvelopeOpenText /> */}
            {JSON.stringify(adherentSel) !== '{}' && (<>
                <AdhesionByUser adherentId={adherentSel.adherent_id} gotoAuth={gotoAuth} unSelAdherent={() => setAdherentSel({})} handleModifAdherent={getData} />
            </>)}
            {JSON.stringify(adherentSel) === '{}' && (<>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>

                    <h1>Adhésion manuelle&nbsp;<Button variant="danger" onClick={() => setShowNew(true)}>+</Button></h1>
                    <div style={{ flexGrow: 1 }} />
                    <ColumnChooser columnsName={columnsSel} data={dataFiltered} setColumns={handleSetColumns} />
                </div>


                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <h1 style={{ marginLeft: '10px' }}>{titre}</h1>

                    <div style={{ flexGrow: 1 }} />
                    <h3 style={{ marginLeft: '10px' }}>{selectedNetwork}</h3>
                    <div style={{ flexGrow: 1 }} />
                    <Form.Select style={{ width: '300px' }} onChange={(e) => handleNetworkFilter(e.target.value)} value={selectedNetwork}>
                        <option value="">Tous les réseaux</option>
                        {uniqueNetworks.map((network, index) => <option key={index} value={network}>{network}</option>)}
                    </Form.Select>

                </div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {/* <h1 style={{ marginLeft: '10px' }}>Adhésion</h1> */}
                    <div style={{ flexGrow: 1 }} />
                    <h3 style={{ marginLeft: '10px' }}>{selectedFeuille}</h3>
                    <div style={{ flexGrow: 1 }} />
                    <Form.Select style={{ width: '300px' }} onChange={(e) => handleFeuilleFilter(e.target.value)} value={selectedFeuille}>
                        <option value="">Toutes les feuilles</option>
                        {uniqueFeuilles.map((feuille, index) => <option key={index} value={feuille}>{feuille}</option>)}
                    </Form.Select>

                </div>

                <DataTable
                    columns={columns}
                    data={dataFiltered}
                    pagination={true}
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                    highlightOnHover
                    subHeader
                    subHeaderComponent={(

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                            <input
                                type="text"
                                value={searchText}
                                onChange={handleChangesearchText}
                                // onChange={(e) => setSearchText(e.target.value)}
                                placeholder="Rechercher..."
                            />
                            {searchText && <FaTimes className='h-5' onClick={() => filtre('', data)} />}
                            <div style={{ flexGrow: 1 }} />
                            <GenereCsv data={dataFiltered} fichier="Adherent" visible={true} />
                        </div>
                    )}
                    defaultSortField="id"
                    defaultSortAsc={false}
                    subHeaderAlign="left"
                    noHeader={true}
                    paginationComponentOptions={{
                        rowsPerPageText: 'Lignes par page:',
                    }}
                    onRowClicked={handleRowClick}
                />
            </>)}

            <Modal size="xl" show={showCotis} onHide={() => setShowCotis(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Cotisation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InfoCotisation cotisation={cotisationSel} choix_id={adherentSel.choix_id} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showCotisSel} onHide={() => setShowCotisSel(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Sélection d'une cotisation pour <b>{adherentSel.nom_de_l_entreprise}</b> - {adherentSel.civilite}. {adherentSel.prenom_adherent} {adherentSel.nom_adherent}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Button variant='outline-danger' onClick={handleDelCotisation}><FaTrash /></Button>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CotisationSel gotoAuth={gotoAuth} handleChoixCotisation={handleChoixCotisation} closemodal={() => setShowCotisSel(false)} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showTarif} onHide={() => setShowTarif(false)}>
                <Modal.Header closeButton>
                    <Modal.Title><b>Selection du tarif</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TarifManuel adherentSel={adherentSel} reloadData={getData} />
                </Modal.Body>
            </Modal>
            <Modal size="xl" show={showMaj} onHide={() => setShowMaj(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Modification</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/*
                    reloadData, blocs, champs, adherentId, code, gotoAuth
                    */}
                    <AdherentUpdateById reloadData={getData} blocs={blocs} champs={champs} code={code} adherentId={adherentIdSel} gotoAuth={gotoAuth} close={()=> setShowMaj(false)} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showNew} onHide={() => setShowNew(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Nouvel adhérent</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AdherentNewUpdate handleSaveAdherent={handleSaveAdherent} blocs={blocs} champs={champs} cotisation={''} setCotisation={() => console.log('rien')} 
                    cotisation2={''} setCotisation2={() => console.log('rien')} code={code} />
                </Modal.Body>
            </Modal>

        </div >
    );
}

export default AdhesionManuelle;
